import { createContext } from 'react'

export interface CarouselContext {
  activeIndex: number
  setActiveIndex: (index: number) => void
  itemCount: number
}

export const CarouselContext = createContext<CarouselContext>({
  activeIndex: 0,
  setActiveIndex: () => undefined,
  itemCount: 0,
})
